<main class="custom-route-desktop">
  <!--@switch (desktopViewState()) {
    @case (customRouteDesktopViews.map) {-->
      <!--@if (isWelcomeViewShown()) {
        <app-welcome-planner-view />
      }-->
      <app-planner [class.no-satured-points]="noSaturedPoints()" />
      <app-map 
        [style.view-transition-name]="'route-map'"
        [class.no-satured-points]="noSaturedPoints()"
      />
      <!--<app-actions-footer-bar />-->
    <!--}
    @case (customRouteDesktopViews.more) {
      <app-more />
    }
  }-->
</main>